import { render } from "./PricingCancelled.vue?vue&type=template&id=352fd956&scoped=true"
import script from "./PricingCancelled.vue?vue&type=script&lang=js"
export * from "./PricingCancelled.vue?vue&type=script&lang=js"

import "./PricingCancelled.vue?vue&type=style&index=0&id=352fd956&scoped=true&lang=css"

import exportComponent from "/home/kitrin/builds/isoevolve/20261004-205117/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-352fd956"]])

export default __exports__